import { UberPickupCode } from 'components';
import { FailDeliveryIcon, FailPickupIcon } from 'static/icons';
import { LogisticsFailureType } from 'types/logistics-failure-reason';

type SuperExpressProps = {
  isSuperExpress: true;
  pinCode: string;
};

type StandardProps = {
  isSuperExpress?: false;
  type: LogisticsFailureType;
  title: string;
  description: string;
};

type Props = SuperExpressProps | StandardProps;

export function DeliveryFailureAlert(props: Props) {
  const baseClassName =
    'mb-4 ml-5 mr-[35px] flex items-start gap-4 rounded-lg border border-solid border-danger-300 bg-danger-300/10 p-4';

  if (props.isSuperExpress) {
    const { pinCode } = props;

    return (
      <div className={baseClassName}>
        <UberPickupCode
          title="Código de retorno Uber"
          code={pinCode}
          description="Informe esse código quando o entregador retornar com o pedido."
        />
      </div>
    );
  }

  const { type, title, description } = props;

  const Icon =
    type === LogisticsFailureType.DELIVERY ? FailDeliveryIcon : FailPickupIcon;

  return (
    <div className={baseClassName}>
      <Icon className="text-danger-300" />
      <div className="flex flex-grow flex-col items-start gap-1.5">
        <p className="text-left text-base font-bold text-neutral-500">
          {title}
        </p>
        <p className="text-left text-xs text-neutral-500">{description}</p>
      </div>
    </div>
  );
}
